import ClassFilterListingItemContent from './ClassFilterListingItemContent';

export default ClassFilterListingItemContent;
export { ClassFilterListingItemContent };
